<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<template v-if="!Object.keys(data).length">
			<button v-on:click="load()">Load</button>
		</template>
		<template v-else>
			<div class="flex">
				<button :disabled="saving" v-on:click="load()">ReLoad</button>
				<button
					:disabled="saving"
					v-on:click="createProfile()"
					class="small-margin-left"
					v-if="!data.profile.klaviyo_profile_id">Create profile</button>
				<button
					:disabled="saving"
					v-on:click="updateProfile()"
					class="small-margin-left"
					v-if="data.profile.klaviyo_profile_id">Update profile</button>
				<button
					:disabled="saving"
					class="small-margin-left"

					v-on:click="autofix()">Auto-fix</button>

					<!-- v-if="data.profile.klaviyo_profile_id && !data.profile.subscribed_list_default && !data.profile.subscribed_list_noconsent" -->
			</div>
			<div class="input-row small-margin-bottom margin-top">
				<span class="label">Profile ID</span>
				{{ data.profile.klaviyo_profile_id ? data.profile.klaviyo_profile_id : 'Not created' }}
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Last updated</span>
				<Format type="date" :time="true" :value="data.profile.last_updated" />
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Marketing mails</span>
				<div class="flex">
					<div style="width: 150px;">
						{{ data.profile.subscribed_list_default ? 'Subscribed' : 'N/A' }}
					</div>
					<button
						:disabled="saving"
						class="small white"
						v-if="!data.profile.subscribed_list_default"
						v-on:click="subscribe('default');">Subscribe</button>
					<button
						:disabled="saving"
						class="small white small-margin-left"
						v-if="data.profile.subscribed_list_default"
						v-on:click="unsubscribe('default');">Unsubscribe</button>
				</div>
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Transactional emails</span>
				<div class="flex">
					<div style="width: 150px;">
						{{ data.profile.subscribed_list_noconsent ? 'Subscribed' : 'N/A' }}
					</div>
					<button
						:disabled="saving"
						class="small white"
						v-if="!data.profile.subscribed_list_noconsent"
						v-on:click="subscribe('no-consent');">Subscribe</button>
					<button
						:disabled="saving"
						class="small white small-margin-left"
						v-if="data.profile.subscribed_list_noconsent"
						v-on:click="unsubscribe('no-consent');">Unsubscribe</button>
				</div>
			</div>

			<div class="input-row">
				<span class="label">Wants newsletter</span>
				{{ !! Number(data.wants_newsletter) ? 'Yes' : 'No' }} ( {{data.wants_newsletter}} )
			</div>

		</template>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    data: {}
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    subscribe (list) {
      Vue.$api.post('/customer/' + this.id + '/klaviyo/subscription/' + list, {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    unsubscribe (list) {
      Vue.$api.delete('/customer/' + this.id + '/klaviyo/subscription/' + list, {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    updateProfile () {
      Vue.$api.post('/customer/' + this.id + '/klaviyo/update', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    autofix () {
      Vue.$api.post('/customer/' + this.id + '/klaviyo/autofix', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    createProfile () {
      Vue.$api.post('/customer/' + this.id + '/klaviyo', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/customer/' + this.id + '/klaviyo', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      if (!data.profile) {
        data.profile = {}
      }

      this.data = data
    }
  }
}
</script>
